import { render, staticRenderFns } from "./IndexMahasiswa.vue?vue&type=template&id=c9210e14"
import script from "./IndexMahasiswa.vue?vue&type=script&lang=js"
export * from "./IndexMahasiswa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports